(() => {
  const initialise = () => {
    const form = document.getElementById('SEOHelpContact');
    if (!form || !form.classList.contains('nl-form') || form.dataset.contactEnhanced === 'true') return;
    form.dataset.contactEnhanced = 'true';
    form.querySelectorAll('input[required], textarea[required]').forEach((field) => {
      const error = form.querySelector('#' + field.id + 'Error');
      field.addEventListener('invalid', () => {
        field.setAttribute('aria-invalid', 'true');
        if (error) error.hidden = false;
      });
      field.addEventListener('input', () => {
        if (!field.validity.valid) return;
        field.removeAttribute('aria-invalid');
        if (error) error.hidden = true;
      });
    });
    const feedback = form.querySelector('.sh-form-errors[role="alert"], .sh-form-success[role="status"]');
    if (feedback) {
      feedback.focus({ preventScroll: true });
      feedback.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
